const AudioRecordActions = Object.freeze({
  NONE: 0,
  START_RECORD: 1,
  STOP_RECORD: 2,
});

export default (AudioRecordActions);
